import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import FinalCTA from "@/components/sections/FinalCTA";
import { Reveal, Stagger, StaggerItem } from "@/components/motion";
import { SectionHeading } from "@/components/primitives";

const VALUES = [
  { title: "One connected system", desc: "We believe founders deserve one place to run everything — not a dozen tabs." },
  { title: "Honest by default", desc: "We label what's real and what's coming. No vaporware, no pretending." },
  { title: "Built with founders", desc: "Mission 100 puts entrepreneurs at the center of what we build." },
];

const STATS = [
  { k: "1", v: "Connected workspace" },
  { k: "10", v: "Modules planned" },
  { k: "100", v: "Launch Offer members" },
  { k: "∞", v: "Businesses to empower" },
];

export default function About() {
  return (
    <>
      <Seo
        title="About"
        description="StUpEco Workspace exists to help entrepreneurs operate and grow their businesses from one connected, AI-powered workspace."
        path="/about"
      />
      <PageHeader
        eyebrow="About"
        title="We help founders run their businesses from one place."
        subtitle="Our mission is simple: help entrepreneurs operate and grow their businesses from one connected workspace — with AI doing the heavy lifting."
      />
      <section className="border-b border-border py-24 sm:py-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Stagger className="grid gap-5 lg:grid-cols-3">
            {VALUES.map((v) => (
              <StaggerItem key={v.title} className="h-full">
                <div className="flex h-full flex-col gap-3 rounded-3xl border border-border bg-card p-8">
                  <h3 className="font-display text-xl font-semibold tracking-tight">{v.title}</h3>
                  <p className="text-sm leading-relaxed text-muted-foreground">{v.desc}</p>
                </div>
              </StaggerItem>
            ))}
          </Stagger>

          <Reveal className="mt-14 grid gap-px overflow-hidden rounded-3xl border border-border bg-border sm:grid-cols-4">
            {STATS.map((s) => (
              <div key={s.v} className="bg-card p-8 text-center">
                <p className="brand-gradient-text font-display text-4xl font-semibold sm:text-5xl">{s.k}</p>
                <p className="mt-2 text-sm text-muted-foreground">{s.v}</p>
              </div>
            ))}
          </Reveal>
        </div>
      </section>
      <FinalCTA />
    </>
  );
}
